import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cielo-mobile-nav',
  templateUrl: './cielo-mobile-nav.component.html',
  styleUrls: ['./cielo-mobile-nav.component.scss']
})
export class CieloMobileNavComponent implements OnInit {

  @Input() scope;
  menuOpen = false;

  constructor() { }

  ngOnInit(): void { }

  openMenu(): void { this.menuOpen = true; }
  closeMenu(): void { this.menuOpen = false; }
}
